export const MenuList = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "Projects",
    url: "/projects",
  },
  {
    title: "About Me",
    url: "/about",
  },
  {
    title: "Contact Me",
    url: "/contact",
  },
];
